const ChevronDown = ({ open, fill = "#006ba6" }: { open: boolean, fill?: string; }) => {
  return (
    <div className="flex flex-col justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13.652"
        height="8.269"
        className={`
          transform transition-transform duration-300
          ${open ? '-rotate-180' : 'rotate-0'}
        `}
      >
        <path fill={fill} d="M6.826 8.269.5 2.618A1.5 1.5 0 0 1 2.5.38l4.327 3.866L11.154.38a1.5 1.5 0 0 1 2 2.238Z" data-name="Path 525" />
      </svg>
    </div>

  )
}

export default ChevronDown
